module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pback12-62048826c80919f34da4c5ad56e5f538.jpg";